module.exports = __webpack_public_path__ + "img/Vivian_O_2.fbb8a8d5.jpg";